export function topBannerCarousel(blockId, autoplaySpeed = 5) {
    $(`#${blockId}`).on('afterChange', (event, slick, currentSlide, nextSlide) => {
        $(`#${blockId} .slick-slide`).attr('inert', 'true');
        $(`#${blockId} .slick-slide`).eq(currentSlide).removeAttr('inert');
    });

    $(`#${blockId}`).on('init', (slick) => {
        console.log('slick initialized:', slick);

        $(`#${blockId} .slick-slide`).attr('inert', 'true');
        $(`#${blockId} .slick-slide`).eq(0).removeAttr('inert');
    });

    $(`#${blockId}`).slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: autoplaySpeed * 1000,
        arrows: false,
        dots: true,
        fade: true,
        swipe: true,
        speed: 600,
    });
}
